// extracted by mini-css-extract-plugin
export default {"calendar":"pq9jY","calendar__toggler":"Wvr9W","calendar__days":"Tozyv","calendar__divider":"jwEaW","calendar__controls":"YsBAG","calendar__submit":"LPtkv"};